import { Box, BoxProps, Button, Skeleton } from "@mui/material";
import * as React from "react";
import EditLocationAltOutlinedIcon from "@mui/icons-material/EditLocationAltOutlined";
import { LocationDialog, LocationSummary } from "./LocationDialog";
import { useLanguage } from "./Language";
import { BranchLimit, useBranchLimits } from "./BranchLimits";
import { useDialog } from "@tlc/ui/dialog/useDialog";
import { useShowFilterSidebar } from "./pages/search/LSSearchResults";
import { useSkipLinks } from "../hooks/useSkipLinks";

export interface BranchLimitControlProps extends BoxProps {
  onChangeBranchLimits?: (
    newBranchIdentifiers: BranchLimit["identifier"][],
  ) => void;
  isSkipLinkTarget?: boolean;
  skipLinkBtnLabel?: string;
}

export const BranchLimitControl: React.FC<BranchLimitControlProps> = ({
  onChangeBranchLimits = () => {},
  isSkipLinkTarget = false,
  skipLinkBtnLabel = "",
  ...props
}) => {
  const {
    branchLimits,
    selectedBranchIds,
    updateSelectedBranches,
    displayBranchLimitControl,
  } = useBranchLimits();

  const { translate } = useLanguage();

  const { open, closeDialog, openDialog } = useDialog();

  const showFilterSidebar = useShowFilterSidebar();
  const branchLimitsButtonRef = React.useRef<HTMLButtonElement>(null);

  const skipLinks = React.useMemo(() => {
    return isSkipLinkTarget && showFilterSidebar
      ? [
          {
            label: skipLinkBtnLabel,
            targetRef: branchLimitsButtonRef,
            priority: 15,
          },
        ]
      : [];
  }, [isSkipLinkTarget, showFilterSidebar, translate]);

  useSkipLinks(skipLinks);

  return (
    <React.Fragment>
      {displayBranchLimitControl && (
        <Box {...props}>
          {branchLimits && (
            <Button
              tabIndex={-1}
              ref={branchLimitsButtonRef}
              startIcon={<EditLocationAltOutlinedIcon />}
              onClick={openDialog}
            >
              <LocationSummary
                prefixText={translate("searching")}
                branchLimits={branchLimits}
                selected={selectedBranchIds}
              ></LocationSummary>
            </Button>
          )}
          {!branchLimits && (
            <Skeleton height={"36.5px"}>
              <Button></Button>
            </Skeleton>
          )}
          {branchLimits && (
            <LocationDialog
              open={open}
              onSubmit={(data) => {
                updateSelectedBranches([...data]);
                onChangeBranchLimits([...data]);
                closeDialog();
              }}
              onClose={closeDialog}
            ></LocationDialog>
          )}
        </Box>
      )}
    </React.Fragment>
  );
};
